module.exports = __webpack_public_path__ + "static/media/gd.03bd9ec8.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/gd.svg
// module id = 651
// module chunks = 0